<template>
    <div class="lawyer_detial no-trans" v-loading="loading">
        <div class="detial_tops">
            <div class="bg_img">
                <img src="@/assets/img/index/legal/detial_bg.png" alt="">
            </div>
            <div class="detial_info">
                <div class="detial_info_box">
                    <div class="title_box">
                        <!-- <img src="@/assets/img/login/Frame.png" alt=""> -->
                         <img src="@/assets/img/index/legal/Frame.png" alt="">
                        <router-link class="span1 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/home">首页</router-link> >
                        <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/online">法律咨询</router-link> >
                        <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/lawyer_list">预约律师</router-link> >
                        <span class="span2" aria-current="page">详情</span>
                    </div>
                    <div class="info_box">
                        <div v-if="mobile_view" class="mobile_lawyer_portrait">
                            <img v-if="ls_detial.business_img" :src="ls_detial.business_img" :alt="ls_detial.name || '律师'">
                            <i v-else class="el-icon-user" aria-hidden="true"></i>
                        </div>
                        <div class="name_vips">
                            <div class="names">{{ ls_detial.name }}律师</div>
                            <div class="vips">
                                <img src="@/assets/img/index/legal/vips.png" alt="">/专业会员
                            </div>
                        </div>
                        <div class="address" v-if="ls_detial.work_company">
                            <img src="@/assets/img/index/home/address.png" alt="">
                            {{ ls_detial.work_company }}
                        </div>
                        <div class="teges">
                            
                            {{ get_cause_title(ls_detial.causeIds||'') }}
                        </div>
                        <div class="introduce">
                          {{ ls_detial.serve }}
                        </div>
                        <div class="phones" v-if="ls_detial.show_mobile ">
                             <img src="../../../assets/img/index/legal/phones.png" alt="">
                             <!-- {{ ls_detial.mobile }} -->
                             {{ ls_detial.show_mobile }}
                        </div>
                        <div class="btns_flex">
                            <div class="btns1" @click="handle_xd">在线委托</div>
                            <div class="btns2" @click="handle_xd">预约律师</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detial_check">
                <div class="detial_check_box">
                    <div class="check_flex">
                        <div class="check_item" :class="{'check_item_ac':check_ac==item.state}" v-for="(item,index) in check_list" :key="index" @click="handle_check(item)"
                            :role="mobile_view ? 'button' : null" :tabindex="mobile_view ? 0 : null" :aria-pressed="mobile_view ? String(check_ac==item.state) : null"
                            @keydown.enter.prevent="handle_check(item)" @keydown.space.prevent="handle_check(item)">
                            <div class="texts">{{ item.title }}</div>
                            <div class="borders"></div>
                        </div>
                    </div>

                  
                   
                </div>
            </div>
        </div>
        <div class="detial_boms">
            <div class="detial_boms_box">
                <div class="" v-if="check_ac==1">
                    <lawsuit_serve ref="lawsuit_serve" :ls_detial="ls_detial"></lawsuit_serve>
                </div>
                <div class="" v-if="check_ac==2">
                    <lawsuit_info ref="lawsuit_info" :ls_detial="ls_detial"></lawsuit_info>
                </div>
                <div class="" v-if="check_ac==3">
                    <lawsuit_case ref="lawsuit_case"></lawsuit_case>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import lawsuit_serve from '@/components/legal_advice/lawsuit_detial/lawsuit_serve.vue'
import lawsuit_info from '@/components/legal_advice/lawsuit_detial/lawsuit_info.vue'
import lawsuit_case from '@/components/legal_advice/lawsuit_detial/lawsuit_case.vue'



export default {
    components: {
        lawsuit_serve,
        lawsuit_info,
        lawsuit_case,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            ls_detial:{},
            check_ac:1,
            check_list:[
                {
                    title:'律师服务',
                    state:1,
                },
                {
                    title:'律师信息',
                    state:2,
                },
                {
                    title:'律师案例',
                    state:3,
                }
            ],
            cause_list:[],
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_detial()
        this.get_cause_list()

    },
    methods: {
        handle_xd(){
            this.$router.push({
                path:'/lawyer_sever_list',
                query:{
                    lawyer_id:this.$route.query.id
                }
            })
        },
        get_cause_list(){
            this.$api("cause", {
                
				// type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.cause_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_cause_title(ids){
            let text=''
            let text_list=[]
            let id_list=ids.split(',')
            
            this.cause_list.forEach((e)=>{
                id_list.forEach((v)=>{
                    if(e.id==v){
                        text_list.push(e.title)
                    }
                })
            })
            text=text_list.join(',')
            return text
        },
        handle_check(item){
            this.check_ac=item.state
        },
        get_detial(){
            this.$api("lawyersInfo", {
               id:this.$route.query.id,
			}, "get").then((res) => {
                this.loading = false
                console.log('律师详情',res)
                if (res.code == 1) {
                    this.ls_detial=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.lawyer_detial{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    // padding:21px ;
    padding-bottom: 100px;
    .detial_tops{
        position: relative;

        .bg_img{
            width: 100%;
            height:550px;
            position: absolute;
            z-index: 1;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .detial_info{
            height:550px;
            position: relative;
            
            z-index: 2;
            .detial_info_box{
                width: 1440px;
                height:550px;
                margin: auto;
                // background-color: #FFFFFF;
                .title_box{
                    padding: 21px 0;
                    display: flex;
                    align-items: center;

                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    img{
                        width: 14px;
                        height: 14px;
                    }
                    .span1{
                        cursor: pointer;
                        margin-right: 10px;
                    }
                    .span2{
                        cursor: pointer;
                        margin-left: 10px;
                    }
                    img{
                        margin-right: 10px;
                    }
                }
                .info_box{
                    width: 760px;
                    margin-left: 100px;
                    .name_vips{
                        display: flex;
                        align-items: end;
                        .names{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 40px;
                            color: #FFFFFF;
                        }
                        .vips{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #FFFFFF;
                            margin-left: 20px;
                            img{
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                    .address{
                        display: flex;
                        align-items: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 20px;
                        color: #FFFFFF;
                        padding-top: 21px;
                        img{
                            // width:18px;
                            height: 24px;
                            margin-right: 10px;
                        }
                    }
                    .teges{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        padding-top: 25px;
                    }
                    .introduce{
                        
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        padding-top: 38px;
                    }
                    .phones{
                        display: flex;
                        align-items: end;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 32px;
                        color: #FFFFFF;
                        padding-top: 46px;
                        img{
                            width: 26px;
                            height: 26px;
                            margin-bottom: 5px;
                        }
                    }
                    .btns_flex{
                        display: flex;
                        align-items: center;
                        padding-top: 28px;
                        .btns1{
                            width: 160px;
                            height: 44px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 44px;
                            cursor: pointer;
                            text-align: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #FFFFFF;

                        }
                        .btns2{
                            width: 160px;
                            height: 44px;
                            background: rgba(255,255,255,0.2);
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #FFFFFF; 
                            margin-left: 24px;
                            cursor: pointer;
                            text-align: center;
                            line-height: 44px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #FFFFFF;

                        }
                    }
                }
            }
        }
        .detial_check{
            // width: 1920px;
            height: 64px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            .detial_check_box{
                width: 1440px;
                height: 64px;
                margin: auto;
                .check_flex{
                    display: flex;
                    align-items: center;
                    
                    .check_item{
                        height: 64px;
                        margin-right:100px ;
                        cursor: pointer;
                        .texts{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #666666;
                            line-height: 62px;
                        }
                        .borders{
                            width: 64px;
                            height: 3px;
                            background: #FFFFFF;
                            border-radius: 0px 0px 0px 0px;
                        }
                        &:hover{
                        .texts{
                            color: #377CFD;
                        } 
                        .borders{
                                background: #377CFD;
                            }
                        }
                    }
                    .check_item_ac{
                        .texts{
                            color: #377CFD;
                        } 
                        .borders{
                            background: #377CFD;
                        }
                    }
                }
              
            }
        }
    }
    .detial_boms{
        .detial_boms_box{
            width: 1440px;
            margin: auto;
        }
    }
    
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .lawyer_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .lawyer_detial.no-trans .detial_tops .bg_img {
        min-height: 0;
        height: auto;
        top: auto;
        right: auto;
        bottom: auto;
        left: auto;
        position: relative;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info {
        min-height: 0;
        height: auto;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin: auto;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .title_box {
        padding: 16px 0;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .title_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .title_box .span1 {
        margin-right: 10px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .title_box .span2 {
        margin-left: 10px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin-left: 16px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .name_vips {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .name_vips .names {
        font-size: 24px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .name_vips .vips {
        font-size: 16px;
        margin-left: 16px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .name_vips .vips img {
        width: 20px;
        height: 20px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .address {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 20px;
        padding-top: 16px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .address img {
        height: 24px;
        margin-right: 10px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .teges {
        font-size: 14px;
        padding-top: 16px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .introduce {
        font-size: 14px;
        padding-top: 16px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .phones {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 24px;
        padding-top: 16px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .phones img {
        width: 26px;
        height: 26px;
        margin-bottom: 5px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .btns_flex .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_info .detial_info_box .info_box .btns_flex .btns2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin-left: 16px;
        line-height: 1.6;
        font-size: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_check {
        height: 64px;
        border-radius: 0px 0px 0px 0px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_check .detial_check_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 64px;
        margin: auto;
    }
    .lawyer_detial.no-trans .detial_tops .detial_check .detial_check_box .check_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_check .detial_check_box .check_flex .check_item {
        height: auto;
        margin-right: 16px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .lawyer_detial.no-trans .detial_tops .detial_check .detial_check_box .check_flex .check_item .texts {
        font-size: 16px;
        line-height: 1.6;
    }
    .lawyer_detial.no-trans .detial_tops .detial_check .detial_check_box .check_flex .check_item .borders {
        width: 64px;
        height: 3px;
        border-radius: 0px 0px 0px 0px;
    }
    .lawyer_detial.no-trans .detial_boms .detial_boms_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
}
@media (max-width: 1024px) {
    .lawyer_detial.no-trans {
        .detial_tops .bg_img { display: none; }
        .detial_tops .detial_info { background: #eff4ff; }
        .detial_tops .detial_info .detial_info_box {
            padding: 0 16px 24px;
            .info_box { width: 100%; margin: 0; }
            .info_box .name_vips { gap: 8px 12px; }
            .info_box .name_vips .names { font-size: 26px; line-height: 38px; }
            .info_box .introduce { line-height: 26px; }
            .info_box .phones { font-size: 20px; line-height: 30px; }
            .info_box .btns_flex { flex-wrap: nowrap; gap: 8px; }
            .info_box .btns_flex .btns1, .info_box .btns_flex .btns2 { flex: 1; width: auto; margin: 0; padding: 10px 8px; font-size: 14px; line-height: 24px; }
        }
        .detial_tops .detial_check { height: auto; background: #fff; }
        .detial_tops .detial_check .detial_check_box { height: auto; padding: 0 16px; }
        .detial_tops .detial_check .detial_check_box .check_flex { display: flex; flex-wrap: nowrap; gap: 0; overflow-x: auto; }
        .detial_tops .detial_check .detial_check_box .check_flex .check_item { flex: 1; min-width: 88px; margin: 0; padding: 12px 8px 0; text-align: center; }
        .detial_tops .detial_check .detial_check_box .check_flex .check_item .texts { font-size: 14px; line-height: 24px; }
        .detial_tops .detial_check .detial_check_box .check_flex .check_item .borders { width: 100%; margin-top: 10px; }
        .detial_boms .detial_boms_box { padding: 20px 16px; }
    }
}
@media (max-width: 1024px) {
    .lawyer_detial.no-trans {
        background: #f4f6f9; padding-bottom: 20px;
        .detial_tops .detial_info {
            height: auto; background: #fff;
            .detial_info_box {
                padding-bottom: 20px;
                .title_box { padding: 12px 0 16px; gap: 4px; font-size: 13px; line-height: 22px; color: #87909d; }
                .title_box .span1, .title_box .span2 { margin: 0; }
                .title_box > img { display: none; }
                .info_box {
                    position: relative; padding: 0;
                    .mobile_lawyer_portrait { position: absolute; top: 0; right: 0; display: flex; align-items: center; justify-content: center; width: 76px; height: 96px; background: #edf3fb; border-radius: 4px; overflow: hidden; }
                    .mobile_lawyer_portrait img { display: block; width: 100%; height: 100%; object-fit: cover; object-position: top; }
                    .mobile_lawyer_portrait i { font-size: 36px; color: #9aacc5; }
                    .name_vips { display: block; padding-right: 90px; }
                    .name_vips .names { font-size: 23px; line-height: 33px; color: #303846; overflow-wrap: anywhere; }
                    .name_vips .vips { display: flex; align-items: center; gap: 4px; margin-left: 0; padding-top: 6px; font-size: 13px; line-height: 22px; color: #7686a0; }
                    .name_vips .vips img { width: 18px; height: 18px; object-fit: contain; }
                    .address { display: flex; align-items: flex-start; padding: 8px 90px 0 0; font-size: 13px; line-height: 22px; color: #687587; overflow-wrap: anywhere; }
                    .address img { width: 14px; height: 18px; margin: 2px 5px 0 0; flex-shrink: 0; }
                    .teges { min-height: 36px; padding: 12px 90px 0 0; font-size: 13px; line-height: 23px; color: #377cfd; overflow-wrap: anywhere; }
                    .introduce { padding-top: 12px; font-size: 14px; line-height: 25px; color: #687587; overflow-wrap: anywhere; }
                    .introduce:empty { display: none; }
                    .phones { display: flex; align-items: center; gap: 6px; padding-top: 12px; font-size: 18px; line-height: 28px; color: #303846; }
                    .phones img { width: 20px; height: 20px; margin: 0; }
                    .btns_flex { padding-top: 16px; }
                    .btns_flex .btns1, .btns_flex .btns2 { display: flex; align-items: center; justify-content: center; min-height: 46px; font-size: 15px; border-radius: 4px; }
                    .btns_flex .btns2 { color: #377cfd; background: #f4f8ff; border: 1px solid #377cfd; }
                }
            }
        }
        .detial_tops .detial_check .detial_check_box .check_flex { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .detial_tops .detial_check .detial_check_box .check_flex .check_item { min-width: 0; padding: 12px 4px 0; }
        .detial_tops .detial_check .detial_check_box .check_flex .check_item:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
        .detial_boms .detial_boms_box {
            padding: 12px 16px 0;
            /deep/ .lawsuit_serve.no-trans, /deep/ .lawsuit_info.no-trans {
                .box1, .box2, .box3 { width: 100%; height: auto; margin: 0 0 12px; padding: 16px; background: #fff; border-radius: 0; }
                .title_box { display: flex; align-items: center; padding: 0 0 12px; gap: 8px; }
                .title_box .borders { width: 3px; height: 17px; }
                .title_box .titles { padding: 0; font-size: 17px; line-height: 26px; overflow-wrap: anywhere; }
            }
            /deep/ .lawsuit_serve.no-trans {
                .box1 .list_flex { display: block; padding: 0; }
                .box1 .list_flex .items2 { display: none; }
                .box1 .list_flex .items {
                    display: grid; grid-template-columns: 76px minmax(0, 1fr); gap: 6px 12px; width: 100%; margin: 0; padding: 14px 0; border: 0; border-bottom: 1px solid #edf0f5; border-radius: 0;
                    .imgs { grid-column: 1; grid-row: ~"1 / 4"; width: 76px; height: 76px; overflow: hidden; border-radius: 4px; background: #f3f6fa; }
                    .imgs img { display: block; width: 100%; height: 100%; object-fit: contain; }
                    .item_title { grid-column: 2; margin: 0; padding: 0; font-size: 15px; line-height: 24px; overflow-wrap: anywhere; }
                    .item_tages { grid-column: 2; display: flex; flex-wrap: wrap; gap: 4px; padding: 0; }
                    .item_tages .tage { margin: 0; padding: 0 4px; font-size: 13px; line-height: 22px; }
                    .price_flex { grid-column: 2; display: flex; flex-wrap: wrap; align-items: baseline; gap: 4px 8px; padding: 0; }
                    .price_flex .price { font-size: 19px; line-height: 28px; overflow-wrap: anywhere; }
                    .price_flex .nums { font-size: 13px; line-height: 22px; color: #87909d; }
                }
                .box2 .list_flex { display: block; padding: 0; }
                .box2 .list_flex:empty::after { content: '暂无案例点评'; display: block; padding: 16px 0; text-align: center; color: #87909d; font-size: 14px; line-height: 24px; }
                .box2 .list_flex .items { width: 100%; margin: 0; padding: 14px 0; background: #fff; border-radius: 0; border-bottom: 1px solid #edf0f5; }
                .box2 .list_flex .items .item_titles { font-size: 16px; line-height: 26px; overflow-wrap: anywhere; }
                .box2 .list_flex .items .item_texts { padding-top: 6px; font-size: 14px; line-height: 24px; color: #748092; overflow-wrap: anywhere; }
                .box3 .fraction { padding: 0; }
                .box3 .fraction .fraction_box { padding: 12px; background: #f5f8fd; }
                .box3 .fraction .fraction_box .nums { font-size: 30px; line-height: 40px; }
                .box3 .fraction .check_box { padding: 14px 0; }
                .box3 .fraction .pl_list_box { padding: 0; }
                .box3 .fraction .pl_list_box .item_box { padding: 16px 0; }
                .box3 .fraction .pl_list_box .item_box .pl_info { padding-left: 0; }
                .box3 .fraction .pl_list_box .item_box .user_flex .images,
                .box3 .fraction .pl_list_box .item_box .user_flex .images img { width: 40px; height: 40px; }
                .box3 .fraction .pl_list_box .item_box .pl_info .texts { font-size: 14px; line-height: 25px; overflow-wrap: anywhere; }
            }
            /deep/ .lawsuit_info.no-trans {
                .box1 .text_imgs { display: block; padding: 0; }
                .box1 .text_imgs .jianjie { width: 100%; padding: 0; font-size: 15px; line-height: 28px; overflow-wrap: anywhere; white-space: pre-line; }
                .box1 .text_imgs .imgs { width: 100%; margin-top: 16px; }
                .box1 .text_imgs .imgs img { display: block; width: 100%; max-height: 240px; object-fit: contain; }
                .box2 { display: block; }
                .box2 .box_inof { width: 100%; padding: 0; margin: 0 0 20px; }
                .box2 .box_inof .info_box { padding: 0; }
                .box2 .box_inof .info_box .info_flex { display: grid; grid-template-columns: 72px minmax(0, 1fr); gap: 12px; padding: 7px 0; margin: 0; }
                .box2 .box_inof .info_box .info_flex .info_title { width: auto; font-size: 13px; line-height: 24px; color: #87909d; }
                .box2 .box_inof .info_box .info_flex .info_text { width: auto; font-size: 14px; line-height: 24px; overflow-wrap: anywhere; }
                .box2 .box_inof .info_box .info_flex .info_text:empty::after { content: '未填写'; color: #a0a9b6; }
                .box1 .list_box { padding: 0; }
                .box1 .list_box:empty::after { content: '暂无公开案例'; display: block; padding: 24px 0; text-align: center; color: #87909d; font-size: 14px; line-height: 24px; }
                .box1 .list_box .lists { padding: 14px 0; margin: 0; background: #fff; border-bottom: 1px solid #edf0f5; }
                .box1 .list_box .lists .tages_titles { flex-wrap: wrap; gap: 8px; }
                .box1 .list_box .lists .tages_titles .titles { font-size: 16px; line-height: 26px; overflow-wrap: anywhere; }
                .box1 .list_box .lists .title_flex { padding-top: 8px; font-size: 14px; line-height: 25px; }
            }
        }
    }
}
@media (max-width: 1024px) {
    .lawyer_detial.no-trans .detial_boms .detial_boms_box /deep/ .lawsuit_serve.no-trans .box3 .fraction {
        .fraction_box {
            display: flex; flex-wrap: nowrap; align-items: center; gap: 14px; padding: 14px;
            background: #f3f7fd; border-radius: 4px;
            .nums { font-size: 34px; line-height: 44px; font-weight: 600; color: #2d5eaa; }
            .pl_star { padding: 0; }
            .pl_star .star_text { font-size: 13px; line-height: 22px; color: #748092; }
            .pl_star .star_num { display: flex; gap: 4px; padding-top: 4px; }
            .pl_star .star_num .star_item, .pl_star .star_num img { width: 16px; height: 16px; margin: 0; }
        }
        .check_box {
            display: block; width: 100%; padding: 14px 0; background: #fff;
            .check_title { width: auto; margin: 0 0 8px; font-size: 13px; line-height: 22px; color: #748092; }
            .check_flex { display: flex; flex-wrap: wrap; gap: 6px; }
            .check_flex .check_item { min-height: 0; margin: 0; padding: 4px 8px; border: 0; border-radius: 4px; background: #f0f5fc; color: #5976a1; font-size: 13px; line-height: 22px; }
        }
        .pl_list_box {
            .item_box {
                display: block; padding: 18px 0; border-bottom: 1px solid #edf0f5;
                .user_flex { display: flex; flex-wrap: nowrap; align-items: center; gap: 10px; height: auto; min-height: 36px; }
                .user_flex .images, .user_flex .images img { flex: 0 0 36px; width: 36px; height: 36px; border-radius: 50%; object-fit: cover; }
                .user_flex .user_info { flex: 1; min-width: 0; padding: 0; }
                .user_flex .user_info .user_name { font-size: 14px; line-height: 23px; font-weight: 500; color: #43526a; overflow-wrap: anywhere; }
                .user_flex .user_info .user_time { margin-top: 0; font-size: 13px; line-height: 21px; color: #87909d; }
                .pl_info {
                    width: 100%; padding: 10px 0 0;
                    .pl_star_num { display: flex; gap: 3px; padding: 0; }
                    .pl_star_num .star_item, .pl_star_num .star_item img { width: 14px; height: 14px; margin: 0; }
                    .tage_list { display: flex; flex-wrap: wrap; gap: 6px; padding: 8px 0 0; }
                    .tage_list:empty { display: none; }
                    .tage_list .item_tage { margin: 0; padding: 2px 6px; font-size: 13px; line-height: 22px; color: #748092; border: 0; border-radius: 4px; background: #f5f7fa; }
                    .texts { width: 100%; padding-top: 8px; font-size: 14px; line-height: 26px; color: #43526a; white-space: pre-line; overflow-wrap: anywhere; }
                }
                &:last-child { border-bottom: 0; }
            }
            .reviews_empty { padding: 28px 0; text-align: center; color: #87909d; font-size: 14px; line-height: 24px; }
            .btns_flex { padding: 14px 0 0; }
            .btns_flex .btns { display: flex; align-items: center; justify-content: center; width: 100%; min-height: 44px; padding: 10px; border: 1px solid #e5eaf1; border-radius: 4px; color: #5976a1; font-size: 14px; line-height: 24px; }
        }
    }
}
</style>
